import { sessionId } from 'mailup-react-helpers'
import {
  Button,
  BUTTON_VARIANT_SECONDARY,
  Flex,
  FlexItem,
  Panel,
  Text,
  Title,
  TITLE_VARIANT_M
} from 'mailup-web-components'
import { useIntl } from 'react-intl'
import { generatePath, useParams } from 'react-router-dom'

import { openBrowserPopup } from 'Helpers/browserPopup'

const BoxOnScreen = () => {
  const { id } = useParams()
  const intl = useIntl()

  const handleOpenPopup = () => {
    const pathPreview = generatePath(
      '/:sessionId/messages/email/:idMessage/preview',
      {
        sessionId: sessionId,
        idMessage: id
      }
    )
    openBrowserPopup(pathPreview)
  }
  return (
    <Panel>
      <Flex flexDirection='column' rowGap='8px'>
        <FlexItem margin='0 0 8px 0'>
          <Title variant={TITLE_VARIANT_M}>
            {intl.formatMessage({
              id: 'Load.EmailCheckUp.PreviewUsingYourBrowserNew'
            })}
          </Title>
        </FlexItem>

        <Text>
          {intl.formatMessage({
            id: 'Load.EmailCheckUp.PreviewViewBrowserPreviewMsgNew'
          })}
        </Text>

        <FlexItem>
          <Flex alignItems='flex-start'>
            <Button
              onClick={handleOpenPopup}
              kind={BUTTON_VARIANT_SECONDARY}
              data-mu-test='browser-preview'
            >
              {intl.formatMessage({
                id: 'Load.EmailCheckUp.PreviewViewBrowserPreviewBtn'
              })}
            </Button>
          </Flex>
        </FlexItem>
      </Flex>
    </Panel>
  )
}

export default BoxOnScreen
